var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 450",
    style: {
      enableBackground: "new 0 0 500 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE9321;}\n\t.st1{fill:#217cee;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    className: "st1",
    d: "M448,27v34.6L42.3,142.8c-23.1,4.6-39.8,25-39.8,48.6v67.3c0,23.6,16.7,43.9,39.8,48.6l9.7,1.9v57.5 c0,23.5,16.6,43.8,39.6,48.5l99,20.4c26.8,5.5,52.9-11.8,58.4-38.6c0.7-3.3,1-6.6,1-9.9v-38.3l198,39.6V423 c0,13.7,11.1,24.8,24.8,24.8s24.8-11.1,24.8-24.8V27c0-13.7-11.1-24.8-24.8-24.8S448,13.3,448,27z M200.5,357.7 c0,13.7-11.1,24.7-24.8,24.7c-1.7,0-3.3-0.2-4.9-0.5l-49.5-10.2c-11.5-2.4-19.8-12.5-19.8-24.3V319l99,19.8V357.7z M448,338.9 L71.8,263.6C60.3,261.3,52,251.1,52,239.4v-28.7c0-11.8,8.3-21.9,19.8-24.3L448,111.1V338.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconNew);
export default __webpack_public_path__ + "static/media/notification_icon_new.58d225932e8dafb4bbba7f5c5fdc271b.svg";
export { ForwardRef as ReactComponent };